import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams  } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  private organizationPromise = null;
  private orgUsersPromise = null;
  private rolesPromise = null;

  constructor(private client: HttpClient) { }

  getOrganization() {
    if(this.organizationPromise == null){
        this.organizationPromise = this.client.get(`${environment.apiBaseUrl}/v1/public/organization`).toPromise();
    }

    return this.organizationPromise;
  }

  uploadImage(organization, image){
      const uploadData = new FormData();
      console.log(image);
      uploadData.append('myFile', image, image.name);
      console.log(uploadData);
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization/${organization}/image/${image.name}/upload`, uploadData)
      .toPromise().then((res) => {
          // Reset cached organization data so subsequent calls fetch the updated image
          this.organizationPromise = null;
          return res;
      });
      /*const uploadData = new FormData();
    uploadData.append('myFile', this.selectedFile, this.selectedFile.name);


    this.http.post('my-backend.com/file-upload', uploadData, {
        reportProgress: true,
        observe: 'events'
    })
    .subscribe(event => {
        console.log(event); // handle event here
    });*/
  }

  createUser(organization, user){
      const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json'
            })
       };

      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization/${organization.name}/user/create`, user, httpOptions).toPromise().then((res) => {
        this.orgUsersPromise = null;
        return res;
      });
  }

  updateUser(organization, user){
      const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json'
            })
       };

      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization/${organization.name}/user/${user.id}`, user, httpOptions).toPromise().then((res) => {
        this.orgUsersPromise = null;
        return res;
      });
  }

  getUsers(organization, page?: number, pageSize?: number) {
    let params = new HttpParams();
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    
    // Clear cache when pagination is used
    if (page !== undefined || pageSize !== undefined) {
      this.orgUsersPromise = null;
    }
    
    if(this.orgUsersPromise == null){
        this.orgUsersPromise = this.client.get(`${environment.apiBaseUrl}/v1/admin/organization/${organization.name}/users`, { params }).toPromise();
    }

    return this.orgUsersPromise;
  }

  deleteUser(organization, user) {
          return this.client.delete(`${environment.apiBaseUrl}/v1/admin/organization/${organization.name}/user/${user.id}`).toPromise().then((res) => {
                  this.orgUsersPromise = null;
    })
  }

  getUserRoles() {
    if(this.rolesPromise == null) {
        this.rolesPromise = this.client.get(`${environment.apiBaseUrl}/v1/admin/roles`).toPromise();
    }
    return this.rolesPromise;
  }

  getExpenseCategories(): Promise<string[]> {
    return this.client.get(`${environment.apiBaseUrl}/v1/admin/expense-categories`).toPromise() as Promise<string[]>;
  }

  updateOrganization(organization){
      const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json'
            })
       };
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization`, organization, httpOptions).toPromise().then((res) => {
        this.organizationPromise = null;
        return res;
      });
  }

  uploadExpense(image: File, category: string, amount: number, useAi: boolean){
      const timestampedName = Date.now() + '-' + image.name;
      const uploadData = new FormData();
      uploadData.append('file', image, timestampedName);
      uploadData.append('category', category);
      uploadData.append('amount', amount.toString());
      uploadData.append('useAi', useAi.toString());
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization/expenses/${timestampedName}/upload`, uploadData)
        .toPromise()
        .then((res) => {
        this.organizationPromise = null;
        return res;
      });
  }

  updateExpense(expense){
      const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json'
            })
       };
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/expenses/${expense.id}`, expense, httpOptions).toPromise().then((res) => {
          this.organizationPromise = null;
          return res;
      });
  }

  getExpenseById(expenseId: string) {
    return this.client.get(`${environment.apiBaseUrl}/v1/admin/expenses/${expenseId}`).toPromise();
  }

  updateExpenseReceipt(expenseId: string, image: File){
      const timestampedName = Date.now() + '-' + image.name;
      const uploadData = new FormData();
      uploadData.append('file', image, timestampedName);
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/expenses/${expenseId}/receipt/upload`, uploadData).toPromise().then((res) => {
          this.organizationPromise = null;
          return res;
      });
  }

  deleteExpense(expense){
      // Use the general expense delete endpoint (works for both property and organization expenses)
      return this.client.delete(`${environment.apiBaseUrl}/v1/admin/expenses/${expense.id}`).toPromise().then((res) => {
          this.organizationPromise = null;
          return res;
      });
  }

  refreshExpense(expense){
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization/expenses/${expense.id}/refresh`, {}).toPromise().then((res) => {
          this.organizationPromise = null;
          return res;
      });
  }

  refreshExpenses(){
      return this.client.post(`${environment.apiBaseUrl}/v1/admin/organization/expenses/refresh`, {}).toPromise().then((res) => {
          this.organizationPromise = null;
          return res;
      });
  }

  getReceiptImage(path: string) {
    return this.client
      .get(`${environment.apiBaseUrl}${path}`, { responseType: 'blob' })
      .toPromise();
  }

  getAllExpenses(page?: number, pageSize?: number, propertyId?: string) {
    let params = new HttpParams();
    if (page !== undefined && page !== null) {
      params = params.set('page', page.toString());
    }
    if (pageSize !== undefined && pageSize !== null) {
      params = params.set('pageSize', pageSize.toString());
    }
    if (propertyId) {
      params = params.set('propertyId', propertyId);
    }
    return this.client.get(`${environment.apiBaseUrl}/v1/admin/expenses`, { params }).toPromise();
  }

}
